/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import styled from 'styled-components';
import { getDownMedia } from '../styles';

export const TabletUpBr = styled.br`
  ${getDownMedia('md')} {
    display: none;
  }
`;
